export default (function (power) {
  return function (t) {
    return 1 - Math.abs(Math.pow(t - 1, power));
  };
});